<template>
    <td
        class="td-aips table-aips-item table-aips-filter-item"
        :colspan="columnSpan"
    >
        <div
            :style="`padding-right: ${paddingRight}`"
            :class="[
                `${
                    !disableOverflow ? 'overflow-ellipsis' : ''
                } ${alignCssClass}`,
                `${tableType === 'fixed-scrolling' ? 'w-inherit' : 'w-100'}`,
            ]"
        >
            <slot></slot>
        </div>
    </td>
</template>

<script setup>
const props = defineProps({
    alignCssClass: {
        type: String,
        default: null,
    },
    columnName: {
        type: String,
        default: '',
    },
    disableOverflow: {
        type: Boolean,
        default: false,
    },
    columnSpan: {
        type: Number,
        default: 1,
    },
    tableType: {
        type: String,
        default: 'fixed',
    },
    paddingRight: {
        type: String,
        default: null,
    },
});
</script>

<script>
export default {
    name: 'TdAips'
};
</script>
